<template>
  <el-dialog
    :close-on-click-modal="false"
    title="任务线路表"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    width="1000px"
  >
    <section v-loading="getDetailLoading">
      <qx-detail-box
        v-for="(data, index) in detailData"
        :data="data"
        :key="index"
      />

      <el-table
        v-loading="tableData.loading"
        ref="multipleTable"
        :data="tableData.data"
        tooltip-effect="dark"
        height="300"
      >
        <!-- 常规列表项 -->
        <el-table-column
          v-for="(item, index, key) in tableData.title"
          :key="key"
          :prop="item.prop"
          :label="item.label"
          :sortable="item.sortable"
          :filters="item.filters"
          :filter-method="item.filterHandler"
          :min-width="item.minW"
          :width="item.w"
        />
      </el-table>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="customFormPost"
        :loading="subLoading || getDetailLoading"
        >确 定</el-button
      >
    </section>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      originData: {},

      detailData: {
        base: {
          label: '',
          tableData: {
            title: [
              { prop: 'sourceAdderssName', label: '装货地' },
              { prop: 'deliveryTime', label: '装货时间' },
              { prop: 'sourceAdderssDtl', label: '详细地址', span: 1 },
              { prop: 'totalGoodsCount', label: '数量' },
              { prop: 'addressCount', label: '任务线路数量' },
              { prop: 'predictArriveDate', label: '预计到达时间' },
              { prop: 'totalMileage', label: '里程' },
              { prop: 'orderTotalTime', label: '总耗时', span: 1 },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
      },

      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        title: [
          { prop: 'sortId', label: '序号', w: 50 },
          { prop: 'desAdderssName', label: '地址名称', w: 150 },
          { prop: 'desAdderssDtl', label: '详细地址' },
          { prop: 'predictArriveTime', label: '预计到达', w: 150 },
          { prop: 'estimatedStayTime', label: '停留时间（分钟）', w: 150 },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {

    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.originData = item;
      this.detailData.base.tableData.data = item;
      this.tableData.data = item.computeBeanList;
    },

    customFormPost () {
      this.dialogFormVisible = false;
    },
  },
};
</script>

<style>
</style>
